import React from "react";
import Frame from "../../images/Frame.png";
import Car from "../../images/Car.png";
import big from "../../images/big.png";
import Train from "../../images/Train.png";
import { Link, useHistory } from "react-router-dom";

const Category = (props) => {
  const { bookType, imgUrl } = props.type;
  const history = useHistory();
  const handleBook = (bookType) => {
    history.push(`/book/${bookType}`);
  };
  return (
    <div className="mb-3 col-md-4 col-lg-3 col-sm-6 col-xs-12 mt-5 ">
      <div class="card mt-5 pt-3 ml-auto mr-auto" style={{ width: "16rem" }}>
        <img src={imgUrl} class="card-img-top" alt="..."></img>
        <div class="card-body text-center">
          <Link
            onClick={() => handleBook(bookType)}
            style={{
              textTransform: "uppercase",
              color: "Black",
            }}
            class="card-title"
          >
            {bookType}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Category;
